module.exports = __webpack_public_path__ + "images/feature/20161107_02-d98e03c83b7f8833357c4a6e46ab5194.jpg";